import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

export default function AboutIndex() {
  return (
    <div id="content">
      <div class="leftNav">
        <ul>
          <li>
            <NavLink end to="/about">
              Richard Brabazon
            </NavLink>
          </li>
          <li>
            <NavLink to="history">History</NavLink>
          </li>
          <li>
            <NavLink to="team">Our Team</NavLink>
          </li>
        </ul>
      </div>
      <div class="mainContent">
        <Outlet />
      </div>
      <div class="clearer"></div>
    </div>
  );
}
